import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function BookingCancelled() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="mx-auto max-w-md px-5 py-16 text-center" data-testid="booking-cancelled-page">
        <XCircle className="h-12 w-12 mx-auto text-muted-foreground" />
        <h1 className="font-display text-2xl font-extrabold mt-4">Payment cancelled</h1>
        <p className="text-sm text-muted-foreground mt-2">No charge was made. You can pick another time or try again.</p>
        <div className="mt-6 flex justify-center gap-2">
          <Button onClick={() => navigate(-1)} variant="outline" className="rounded-full">Go back</Button>
          <Button onClick={() => navigate("/")} className="rounded-full">Browse events</Button>
        </div>
      </main>
    </div>
  );
}
